import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { NativeLink, palette, Text, typography } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const directorTextStyles = css`
  color: ${palette.slate};
  font-size: 14px;
`

export const DirectorLabel = styled(Text)`
  ${directorTextStyles}

  font-weight: ${typography.fontWeight.bold}
`

export const DirectorText = styled(Text)(directorTextStyles)

export const ProfileImage = styled.img`
  border-radius: 50%;
  cursor: pointer;
  height: 42px;
  object-fit: cover;
  width: 42px;
`

export const SchoolLink = styled(NativeLink)`
  font-size: 18px;
  font-weight: ${typography.fontWeight.bold};
`
